import React from 'react';
import { MoreVerticalIcon } from 'lucide-react';
export function DeviceCard({
  device
}) {
  const {
    name,
    type,
    location,
    status,
    icon: Icon,
    power,
    temperature,
    reading
  } = device;
  return <div className="bg-white rounded-xl shadow-sm p-4 hover:shadow-md transition-shadow" data-id="element-141">
      <div className="flex justify-between items-start mb-3" data-id="element-142">
        <div className={`p-2 rounded-lg ${status === 'on' ? 'bg-green-100' : 'bg-gray-100'}`} data-id="element-143">
          <Icon size={20} className={status === 'on' ? 'text-green-600' : 'text-gray-400'} data-id="element-144" />
        </div>
        <button className="text-gray-400 hover:text-gray-600" data-id="element-145">
          <MoreVerticalIcon size={18} data-id="element-146" />
        </button>
      </div>
      <h3 className="font-medium" data-id="element-147">{name}</h3>
      <p className="text-sm text-gray-500 mb-3" data-id="element-148">{location}</p>
      <div className="flex justify-between items-center" data-id="element-149">
        <div data-id="element-150">
          <span className={`inline-block w-2 h-2 rounded-full mr-1 ${status === 'on' ? 'bg-green-500' : 'bg-gray-400'}`} data-id="element-151"></span>
          <span className="text-sm text-gray-600 capitalize" data-id="element-152">{status}</span>
        </div>
        {power && <span className="text-sm font-medium text-gray-700" data-id="element-153">{power}</span>}
        {temperature && <span className="text-sm font-medium text-gray-700" data-id="element-154">
            {temperature}
          </span>}
        {reading && <span className="text-sm font-medium text-gray-700" data-id="element-155">{reading}</span>}
      </div>
    </div>;
}